import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class CursosService {
  constructor(private api: CloudFunctionsApiService) {}

  getCursos() {
    return this.api.snapshotList('/courses');
  }

  getCursosNow() {
    return this.api.getCollection('/courses');
  }

  getCursosById(uid) {
    return this.api.documentChange(`/courses/${uid}`);
  }

  createdCurso(curso) {
    return this.api.post('/courses', curso).toPromise();
  }

  editCurso(uid, curso) {
    return this.api.patch(`/courses/${uid}`, curso).toPromise();
  }

  getCursosByColegioid(uid) {
    return this.api.snapshotList(`/courses/school/${uid}`);
  }

  getCursosByColegioidNow(uid) {
    return this.api.getCollection(`/courses/school/${uid}`);
  }

  getCursosByColegioidOrdenado(uid) {
    return this.getCursosByColegioid(uid);
  }

  getCursosByClassid(classuid) {
    return this.api.snapshotList(`/courses?classId=${encodeURIComponent(classuid)}`);
  }

  getCursosByClassidNow(classuid) {
    return this.api.getCollection(`/courses?classId=${encodeURIComponent(classuid)}`);
  }

  deleteCurso(uid) {
    return this.api.delete(`/courses/${uid}`).toPromise();
  }

  addClassToCourse(courseId, classId) {
    return this.api.post(`/courses/${courseId}/classes/${classId}`).toPromise();
  }

  removeClassFromCourse(courseId, classId) {
    return this.api.delete(`/courses/${courseId}/classes/${classId}`).toPromise();
  }
}
